export default __webpack_public_path__ + "static/media/mywork.91618571.svg";